<template>
    <div>
        <!-- Scalev Integration Info Modal — muncul saat top up senilai Paket Bulanan -->
        <div v-if="showScalevTopupWarning" class="scalev-modal-backdrop">
            <div class="scalev-modal-content">
                <div class="scalev-modal-header">
                    <i class="fas fa-info-circle text-warning"></i>
                    <h5 class="mb-0 ml-2">Mau Integrasi ke Scalev?</h5>
                </div>
                <div class="scalev-modal-body">
                    <p class="mb-2">
                        Nominal top up Kakak <strong>{{ formatRp(parseInt(form.nominal)) }}</strong> setara dengan <strong>Paket Bulanan</strong>.
                    </p>
                    <div class="alert alert-warning mb-3">
                        <i class="fas fa-info-circle mr-2"></i>
                        Fitur <strong>Integrasi ke Scalev</strong> hanya tersedia untuk <strong>Paket minimal 6 Bulan atau 1 Tahun</strong>.
                    </div>
                    <p class="mb-1">Jika Kakak ingin pakai Scalev, top up minimal senilai paket berikut:</p>
                    <ul class="mb-2">
                        <li>Paket <strong>6 Bulan</strong>: <strong>{{ formatRp(scalevPrices.sixMonth) }}</strong></li>
                        <li>Paket <strong>1 Tahun</strong>: <strong>{{ formatRp(scalevPrices.yearly) }}</strong></li>
                    </ul>
                    <p class="mb-0 text-muted" style="font-size:13px">
                        Jika lanjut top up {{ formatRp(parseInt(form.nominal)) }}, artinya Kakak setuju tanpa fitur Integrasi Scalev.
                    </p>
                </div>
                <div class="scalev-modal-footer">
                    <button type="button" class="btn btn-outline-secondary" @click="continueScalevTopup">
                        Lanjut {{ formatRp(parseInt(form.nominal)) }} (tanpa Scalev)
                    </button>
                    <button type="button" class="btn btn-outline-primary" @click="setNominalScalev('sixMonth')">
                        Top Up {{ formatRp(scalevPrices.sixMonth) }} (6 Bulan)
                    </button>
                    <button type="button" class="btn btn-primary" @click="setNominalScalev('yearly')">
                        Top Up {{ formatRp(scalevPrices.yearly) }} (1 Tahun)
                    </button>
                </div>
            </div>
        </div>

        <div v-if="topupBlocked" class="alert alert-danger">
            <i class="fas fa-ban"></i> <strong>Top Up Diblokir</strong>
            <p class="mb-0 mt-1" style="font-size:13px">{{ topupBlockedReason }}</p>
            <p v-if="topupUnpaidCount > 0" class="mb-0 mt-1 text-muted" style="font-size:12px">Belum dibayar hari ini: {{ topupUnpaidCount }}</p>
        </div>
        <center>
            <h4>Top Up Saldo</h4>
        </center>
        <br>
        <label> Nominal (Rupiah) </label>
        <money class="form-control" v-model="form.nominal" v-bind="money"></money>
        <b v-if="form.low" class="text-danger" style="font-size:12px">Nominal Top Up Minimal adalah Rp 10.000</b>
        <b v-if="form.high" class="text-danger" style="font-size:12px">Nominal Top Up Maksimal adalah Rp 10.000.000</b>
        <br>
        <br>

        <!-- Persetujuan Kebijakan Pembelian -->
        <div class="mb-3" style="background:#f8f9fb;border:1px solid #e9ebf6;border-radius:8px;padding:10px 12px">
            <label class="d-flex mb-0" style="gap:8px;cursor:pointer;align-items:flex-start">
                <input type="checkbox" v-model="agreedPolicy" style="margin-top:3px;flex:0 0 auto">
                <span style="font-size:12px;color:#5b647a;line-height:1.5">
                    Saya telah membaca &amp; menyetujui
                    <router-link to="/billing/kebijakan" target="_blank" style="color:#5F63F2;font-weight:600">Kebijakan Pembelian &amp; Refund</router-link>:
                    saldo/paket yang sudah dibeli <b>tidak dapat di-refund</b>, termasuk bila nomor WhatsApp diblokir/dibatasi/terkena error 463 yang di luar kendali StarSender.
                </span>
            </label>
        </div>

        <!-- StarQRIS QR Modal -->
        <div v-if="showStarQrisModal" class="scalev-modal-backdrop">
            <div class="scalev-modal-content" style="max-width:420px">
                <div class="scalev-modal-header">
                    <i class="fas fa-qrcode text-primary"></i>
                    <h5 class="mb-0 ml-2">Bayar via StarQRIS</h5>
                </div>
                <div class="scalev-modal-body">
                    <StarQrisPayment
                        :transactionId="starqrisTransactionId"
                        :data="starqrisPayment"
                        @paid="onStarQrisPaid"
                        @done="onStarQrisDone"
                        @cancel="closeStarQrisModal"
                    />
                </div>
            </div>
        </div>

        <!-- Manual transfer panel (if showManualForm = true) -->
        <div v-if="showManualForm">
            <ManualTransferForm
                :paymentMode="'topup'"
                :amount="parseInt(form.nominal)"
                :targetLabel="'Top Up Saldo'"
                @cancel="showManualForm = false"
                @success="onManualSuccess"
            />
        </div>

        <div v-else-if="!showStarQrisModal">
            <div class="row" v-if="!isLoading">
                <div class="col-12" v-if="paymentMethods.starqris_enabled" style="margin-bottom:12px">
                    <button type="button" class="ch-card starqris-card" style="--accent:#00b894;width:100%"
                        @click="topup('starqris')" :disabled="form.low || form.high || !agreedPolicy || topupBlocked">
                        <span class="ch-logo no-img"><i class="fas fa-qrcode"></i></span>
                        <span class="ch-name">QRIS via StarQRIS</span>
                        <span class="ch-desc">Scan QR, bayar otomatis</span>
                        <i class="fas fa-chevron-right ch-arrow"></i>
                    </button>
                </div>
                <div class="col-12" v-if="paymentMethods.tripay_enabled">
                    <div v-for="grp in groupedChannels" :key="grp.group" class="ch-group">
                        <div class="ch-group-title">{{ grp.group }}</div>
                        <div class="ch-grid">
                            <button v-for="ch in grp.items" :key="ch.channel_code" type="button"
                                class="ch-card" :style="'--accent:' + (ch.class || '#5F63F2')"
                                @click="topup(ch.channel_code)" :disabled="form.low || form.high || !agreedPolicy || topupBlocked">
                                <span class="ch-logo" :class="{ 'no-img': imgErr[ch.channel_code] }">
                                    <img :src="channelIcon(ch.channel_code)" :alt="ch.channel_name" @error="onImgError(ch.channel_code)">
                                    <i class="fas fa-university"></i>
                                </span>
                                <span class="ch-name">{{ ch.channel_name }}</span>
                                <i class="fas fa-chevron-right ch-arrow"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div v-show="paypalTampil && paymentMethods.tripay_enabled" class="col-md-12" style="margin-top:10px">
                    <button class="btn-topup btn btn-block text-white" style="background-color:#3786c5" name="method"
                        v-on:click="topup('paypal')" :disabled="form.low || form.high || topupBlocked"> PayPal
                    </button>
                </div>

                <div v-if="!paymentMethods.tripay_enabled && !paymentMethods.manual_transfer_enabled && !paymentMethods.starqris_enabled" class="col-md-12">
                    <div class="alert alert-warning">
                        Tidak ada metode pembayaran tersedia saat ini. Silakan hubungi admin.
                    </div>
                </div>

                <div v-if="paymentMethods.manual_transfer_enabled" class="col-md-12" style="margin-top:10px">
                    <button class="btn btn-block btn-warning"
                        v-on:click="openManualTransfer"
                        :disabled="form.low || form.high || topupBlocked">
                        <i class="fas fa-university"></i> Bayar via Transfer Manual
                    </button>
                    <small class="text-muted d-block mt-1 text-center">
                        Transfer ke rekening admin → upload bukti → admin verify
                    </small>
                </div>
            </div>
            <div v-else>
                <button
                    class="btn btn-primary btn-block btn-default btn-squared text-capitalize mx-auto d-block" disabled>
                    <div class="spinner-border spinner" role="status"></div>
                    Loading
                </button>
            </div>
        </div>

    </div>
</template>


<script>
    import {
        Money
    } from 'v-money'
    import axios from 'axios'
    import ManualTransferForm from '@/components/forms/billing/ManualTransferForm.vue'
    import StarQrisPayment from '@/components/forms/billing/StarQrisPayment.vue'

    export default {
        components: {
            Money,
            ManualTransferForm,
            StarQrisPayment,
        },
        data() {
            return {
                form: {
                    nominal: 0,
                    low: true,
                    high: false,
                },
                payment_channel: [],
                imgErr: {},
                money: {
                    thousands: '.',
                    precision: 0,
                },
                isLoading: false,
                paypalTampil: false,
                paymentMethods: { tripay_enabled: true, manual_transfer_enabled: false, starqris_enabled: false, banks: [] },
                showStarQrisModal: false,
                starqrisPayment: {},
                starqrisTransactionId: '',
            topupBlocked: false,
            topupBlockedReason: "",
            topupUnpaidCount: 0,
                showManualForm: false,
                // Scalev top-up info popup
                showScalevTopupWarning: false,
                scalevAcknowledged: false,
                pendingAction: null,
                scalevPrices: { monthly: 99000, sixMonth: 599000, yearly: 799000 },
                agreedPolicy: false,
            };
        },
        computed: {
            groupedChannels() {
                const groups = {};
                (this.payment_channel || []).forEach(ch => {
                    const g = ch.group || 'Lainnya';
                    (groups[g] = groups[g] || []).push(ch);
                });
                const order = ['Virtual Account', 'E-Wallet', 'Convenience Store'];
                const rank = (x) => (order.indexOf(x) < 0 ? 99 : order.indexOf(x));
                return Object.keys(groups)
                    .sort((a, b) => rank(a) - rank(b))
                    .map(g => ({ group: this.groupLabel(g), items: groups[g] }));
            },
        },
        watch: {
            form: {
                handler(val) {
                    if (val.nominal < 10000) {
                        val.high = false
                        val.low = true
                    } else if (val.nominal >= 10000 && val.nominal <= 10000000) {
                        val.low = false
                        val.high = false
                    } else {
                        val.high = true
                        val.low = false
                    }
                },
                deep: true
            },
        },
        beforeDestroy() {
            this.$root.$off("toggle_modal", this.fnToggleModal);
        },
        mounted() {
            this.fnToggleModal = (param) => {
                this.toggleModal(param);
            }
            this.$root.$on("toggle_modal", this.fnToggleModal);

            this.fetchPaymentChannel()
            this.fetchPaymentMethods()
            this.fetchScalevPrices()
        },
        methods: {
            recordAgreement() {
                try {
                    axios.post('billing/agree-policy', { context: 'topup', reference: 'nominal:' + this.form.nominal }).catch(() => { /* noop */ });
                } catch (e) { /* noop */ }
            },
            channelIcon(code) {
                const map = {
                    PERMATAVA: 'https://assets.tripay.co.id/upload/payment-icon/szezRhAALB1583408731.png',
                    BNIVA: 'https://assets.tripay.co.id/upload/payment-icon/n22Qsh8jMa1583433577.png',
                    BRIVA: 'https://assets.tripay.co.id/upload/payment-icon/8WQ3APST5s1579461828.png',
                    MANDIRIVA: 'https://assets.tripay.co.id/upload/payment-icon/T9Z012UE331583531536.png',
                    BCAVA: 'https://assets.tripay.co.id/upload/payment-icon/ytBKvaleGy1605201833.png',
                    MUAMALATVA: 'https://assets.tripay.co.id/upload/payment-icon/GGwwcgdYaG1611929720.png',
                    CIMBVA: 'https://assets.tripay.co.id/upload/payment-icon/WtEJwfuphn1614003973.png',
                    BSIVA: 'https://assets.tripay.co.id/upload/payment-icon/tEclz5Assb1643375216.png',
                    DANAMONVA: 'https://assets.tripay.co.id/upload/payment-icon/F3pGzDOLUz1644245546.png',
                    ALFAMART: 'https://assets.tripay.co.id/upload/payment-icon/jiGZMKp2RD1583433506.png',
                    INDOMARET: 'https://assets.tripay.co.id/upload/payment-icon/zNzuO5AuLw1583513974.png',
                    ALFAMIDI: 'https://assets.tripay.co.id/upload/payment-icon/aQTdaUC2GO1593660384.png',
                    QRIS: 'https://assets.tripay.co.id/upload/payment-icon/BpE4BPVyIw1605597490.png',
                    QRIS2: 'https://assets.tripay.co.id/upload/payment-icon/8ewGzP6SWe1649667701.png',
                };
                return map[code] || '';
            },
            groupLabel(g) {
                return ({
                    'Virtual Account': 'Transfer Bank (Virtual Account)',
                    'E-Wallet': 'QRIS / E-Wallet',
                    'Convenience Store': 'Minimarket / Retail',
                })[g] || g;
            },
            onImgError(code) {
                this.$set(this.imgErr, code, true);
            },
            formatRp(v) {
                const n = parseInt(v) || 0;
                return 'Rp ' + n.toLocaleString('id-ID');
            },
            async fetchScalevPrices() {
                // Ambil harga paket utama (bulanan/6 bulan/tahunan) untuk popup Scalev.
                try {
                    const r = await this.$store.dispatch('package_list');
                    let pkgs = (r.data && r.data.data) || [];
                    if (!Array.isArray(pkgs)) pkgs = pkgs.packages || [];
                    const cheapestIn = (minD, maxD) => {
                        const cand = pkgs.filter(p => p.is_addon != 1 && p.price > 0 &&
                            p.duration >= minD && p.duration <= maxD);
                        if (!cand.length) return 0;
                        return cand.reduce((a, b) => (b.price < a.price ? b : a)).price;
                    };
                    const m = cheapestIn(28, 31);
                    const s = cheapestIn(170, 190);
                    const y = cheapestIn(360, 370);
                    if (m) this.scalevPrices.monthly = m;
                    if (s) this.scalevPrices.sixMonth = s;
                    if (y) this.scalevPrices.yearly = y;
                } catch (e) { /* pakai fallback default */ }
            },
            shouldWarnScalev() {
                const n = parseInt(this.form.nominal) || 0;
                const m = this.scalevPrices.monthly;
                // Hanya untuk nominal kecil yang "senilai paket bulanan" (Rp 99rb s/d < 2x bulanan ~Rp 198rb).
                // Top up Rp 200rb ke atas dianggap sudah sengaja besar -> lanjut tanpa popup.
                return m > 0 && n >= m && n < m * 2;
            },
            continueScalevTopup() {
                this.scalevAcknowledged = true;
                this.showScalevTopupWarning = false;
                const a = this.pendingAction;
                this.pendingAction = null;
                if (a && a.type === 'channel') this.topup(a.channel);
                else if (a && a.type === 'manual') this.showManualForm = true;
            },
            setNominalScalev(which) {
                const v = which === 'yearly' ? this.scalevPrices.yearly : this.scalevPrices.sixMonth;
                this.form.nominal = v;
                this.form.low = false;
                this.form.high = false;
                this.scalevAcknowledged = false;
                this.pendingAction = null;
                this.showScalevTopupWarning = false;
            },
            async fetchPaymentChannel() {
                try {
                    let payment_channel = await this.$store.dispatch('payment_channel')
                    this.payment_channel = payment_channel.data.data.payment_channel || []
                } catch (err) {
                    this.$toast.error(err.response.data.message)
                }
            },
            async fetchPaymentMethods() {
                try {
                    const r = await axios.get('payment/methods')
                    if (r.data && r.data.success) {
                        this.paymentMethods = r.data.data
                        this.topupBlocked = !!(r.data.data && r.data.data.topup_blocked)
                        this.topupBlockedReason = (r.data.data && r.data.data.topup_blocked_reason) || ""
                        this.topupUnpaidCount = parseInt((r.data.data && r.data.data.topup_unpaid_count) || 0)
                    }
                } catch (err) {
                    // silent — fallback to default (tripay only)
                }
            },
            openManualTransfer() {
                if (!this.agreedPolicy) { this.$toast.warning("Mohon setujui Kebijakan Pembelian & Refund terlebih dahulu"); return; }
                this.recordAgreement();
                if (this.form.low || this.form.high) {
                    this.$toast.warning('Nominal tidak valid')
                    return
                }
                if (!this.scalevAcknowledged && this.shouldWarnScalev()) {
                    this.pendingAction = { type: 'manual' }
                    this.showScalevTopupWarning = true
                    return
                }
                this.showManualForm = true
            },
            onManualSuccess() {
                this.showManualForm = false
                this.$modal.toggle('topup')
                this.$router.push('/billing/manual-payments')
            },
            async topup(payment_channel) {
                if (this.isLoading) return
                if (!this.agreedPolicy) { this.$toast.warning("Mohon setujui Kebijakan Pembelian & Refund terlebih dahulu"); return; }
                this.recordAgreement();
                //CHECK
                if (this.form.nominal < 10000) {
                    this.form.high = false
                    this.form.low = true
                } else if (this.form.nominal >= 10000 && this.form.nominal <= 10000000) {
                    this.form.low = false
                    this.form.high = false
                } else {
                    this.form.high = true
                    this.form.low = false
                }
                if (this.form.low || this.form.high) return

                // Popup info Scalev kalau top up senilai paket bulanan (sekali saja)
                if (!this.scalevAcknowledged && this.shouldWarnScalev()) {
                    this.pendingAction = { type: 'channel', channel: payment_channel }
                    this.showScalevTopupWarning = true
                    return
                }

                this.isLoading = true
                try {
                    const topup = await axios.post('payment/topup', {
                        nominal: parseInt(this.form.nominal),
                        payment_channel: payment_channel,
                    }, { timeout: 90000 })

                    const data = topup.data && topup.data.data ? topup.data.data : {}
                    const trx = data.transaction || {}

                    if (payment_channel === 'starqris') {
                        if (!data.starqris) {
                            throw new Error('Data QRIS tidak diterima dari server. Silakan coba lagi.')
                        }
                        this.starqrisTransactionId = trx.transaction_id || trx.TransactionID || ''
                        this.starqrisPayment = data.starqris
                        this.showStarQrisModal = true
                        return
                    }

                    const checkoutUrl = trx.checkout_url || trx.CheckoutURL || ''
                    if (!checkoutUrl) {
                        throw new Error('Checkout URL tidak tersedia. Silakan coba metode pembayaran lain.')
                    }
                    window.location.replace(checkoutUrl)
                } catch (err) {
                    let msg = 'Gagal top up'
                    if (err.code === 'ECONNABORTED') {
                        msg = 'Permintaan top up timeout. StarQRIS mungkin sedang lambat — silakan coba lagi.'
                    } else if (err.response && err.response.data && err.response.data.message) {
                        msg = err.response.data.message
                    } else if (err.message) {
                        msg = err.message
                    }
                    this.$toast.error(msg)
                } finally {
                    this.isLoading = false
                }
            },
            closeStarQrisModal() {
                this.showStarQrisModal = false
                this.starqrisPayment = {}
                this.starqrisTransactionId = ''
            },
            onStarQrisPaid() {
                this.$toast.success('Pembayaran berhasil! Saldo telah ditambahkan.')
            },
            onStarQrisDone() {
                this.closeStarQrisModal()
                this.$modal.toggle('topup')
                this.$router.push('/billing?success=true')
            },
            chunkArray(arr, n) {
                let chunkLength = Math.max(arr.length / n, 1);
                let chunks = [];
                for (let i = 0; i < n; i++) {
                    if (chunkLength * (i + 1) <= arr.length) chunks.push(arr.slice(chunkLength * i, chunkLength * (i +
                        1)));
                }
                return chunks;
            },
            toggleModal(param) {
                this.$modal.toggle(param);
            },
            addStr(str, index, stringToAdd) {
                return str.substring(0, index) + stringToAdd + str.substring(index, str.length);
            }
        },
    };
</script>

<style scoped>
/* Scalev Top-Up Info Modal */
.scalev-modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 11000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    animation: scFadeIn 0.2s ease;
}
.scalev-modal-content {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);
    max-width: 560px;
    width: 100%;
    overflow: hidden;
    animation: scSlideUp 0.25s ease;
}
.scalev-modal-header {
    display: flex;
    align-items: center;
    padding: 1.25rem 1.5rem;
    border-bottom: 1px solid #e9ecef;
    background: linear-gradient(135deg, #fff8e1, #fffbe6);
}
.scalev-modal-header i { font-size: 1.5rem; }
.scalev-modal-header h5 { color: #856404; font-weight: 600; }
.scalev-modal-body {
    padding: 1.5rem;
    font-size: 0.95rem;
    color: #495057;
    line-height: 1.55;
    text-align: left;
}
.scalev-modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
    padding: 1rem 1.5rem;
    background-color: #f8f9fa;
    border-top: 1px solid #e9ecef;
    flex-wrap: wrap;
}
.scalev-modal-footer .btn { flex: 1 1 auto; min-width: 160px; }
@keyframes scFadeIn { from { opacity: 0; } to { opacity: 1; } }
@keyframes scSlideUp { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
@media (max-width: 576px) {
    .scalev-modal-footer .btn { min-width: 100%; }
}

/* ===== Payment channel logo cards ===== */
.ch-group { margin-bottom: 18px; }
.ch-group-title {
    font-size: 11.5px; font-weight: 700; letter-spacing: .05em; text-transform: uppercase;
    color: #8b93a7; margin: 0 2px 9px;
}
.ch-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
@media (max-width: 576px) { .ch-grid { grid-template-columns: 1fr; } }
.ch-card {
    display: flex; align-items: center; gap: 12px; width: 100%; text-align: left;
    background: #fff; border: 1.5px solid #e9ebf6; border-radius: 12px; padding: 11px 14px;
    cursor: pointer; transition: all .18s ease; position: relative; overflow: hidden;
}
.ch-card::before {
    content: ''; position: absolute; left: 0; top: 0; bottom: 0; width: 4px;
    background: var(--accent, #5F63F2); opacity: 0; transition: opacity .18s;
}
.ch-card:hover:not(:disabled) {
    border-color: var(--accent, #5F63F2);
    box-shadow: 0 9px 24px -12px rgba(95, 99, 242, .5); transform: translateY(-2px);
}
.ch-card:hover:not(:disabled)::before { opacity: 1; }
.ch-card:disabled { opacity: .5; cursor: not-allowed; }
.ch-logo {
    flex: 0 0 auto; width: 56px; height: 36px; display: flex; align-items: center;
    justify-content: center; background: #f6f7fc; border: 1px solid #eef0f8; border-radius: 8px;
}
.ch-logo img { max-width: 46px; max-height: 26px; object-fit: contain; }
.ch-logo i { display: none; color: var(--accent, #5F63F2); font-size: 18px; }
.ch-logo.no-img img { display: none; }
.ch-logo.no-img i { display: inline-block; }
.ch-name { flex: 1 1 auto; font-weight: 600; font-size: 13.5px; color: #2b3042; line-height: 1.25; }
.ch-desc { display: block; font-size: 11px; font-weight: 400; color: #8b93a7; margin-top: 2px; }
.starqris-card .ch-name { display: flex; flex-direction: column; }
.ch-arrow { flex: 0 0 auto; color: #c3c8da; font-size: 13px; transition: .18s; }
.ch-card:hover:not(:disabled) .ch-arrow { color: var(--accent, #5F63F2); transform: translateX(2px); }
</style>
